import { isWebApp, setServerUrl, translateError, useIsMobileApp } from '../store/api/CommonFunctions';
import { useState, useEffect, Fragment } from 'react';
import { useDispatch } from 'react-redux';
import { useForm } from 'react-hook-form';
import Loader from 'react-loader-spinner';
import { Button, Card, Col, Form } from 'react-bootstrap';
import { Key, Person, ShieldLock } from 'react-bootstrap-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDoorOpen } from '@fortawesome/free-solid-svg-icons';
const company = localStorage.getItem("Company");

const Login = (props) => {
  const dispatch = useDispatch();
  const isMobile = useIsMobileApp();
  let dialogData = {
    status: 'show',
    arrayBtn: ['ok'],
    dialogTitle: '',
    dialogText: ' '
  };

  const setErrorDialog = (message, title) => {
    const text = translateError(message) || message; // اگر پیام تعریف نشده بود، خودش رو نشون بده

    const dialog = {
      ...dialogData,
      dialogTitle: title,
      dialogText: text
    };

    dispatch({
      type: "SET_DIALOG",
      data: dialog
    });
  };

  const url = "api/accountapi/LoginAPI?username={username}&password={password}";
  useEffect(() => {
    document.body.classList = "notMain";
  }, []);
  const [isLoading, setLoading] = useState(false);
  // دریافت URL مربوط به ServerSide
  async function getCompanyServerUrl(compUrl, companyCode) {

    try {
      const response = await fetch(`${compUrl}CompanyAPI/GetServerUrl?RegisterCode=${companyCode}`, {
        method: "GET",
        cache: "no-cache"
      });
      const result = await response.json();
      return result.Data;
    } catch (ex) {
      setErrorDialog("خطا در دریافت آدرس سرور", "ورود به سیستم");
      console.error("Get Company Url:",ex.message);
    }
  }
  // ============================================خواندن config.json============================================
  async function loadConfig(companyCode) {
      const response = await fetch('././config.json', {
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }
      });
      const config = await response.json();
      const currentUrl = localStorage.getItem("ServerUrl");
      if (!currentUrl && companyCode && (!(config.SERVER_URL?.length > 0))) {

        config.SERVER_URL = await getCompanyServerUrl(config.COMP_URL, companyCode);
      }
      else if (currentUrl) {
        config.SERVER_URL = currentUrl;
      }
      if (!(config.SERVER_URL?.length > 0)) {
        setErrorDialog("خطا در دریافت آدرس سرور", "ورود به سیستم");
        setLoading(false);
        return null;
      }
      localStorage.setItem("ServerUrl", config.SERVER_URL);
      setServerUrl(config.SERVER_URL);
      return config;
  }

  // ===================================================لاگین و گرفتن توکن==================================
  async function login(serverUrl, url) {
    const response = await fetch(serverUrl + url, {
      method: 'GET',
      cache: 'no-cache',
      headers: {
        'Content-Type': 'application/json',
        'Data-Type': 'JSON'
      }
    });
    if (response.status === 404) {
      setErrorDialog("نام کاربری یا گذرواژه اشتباه است.", "ورود به سیستم");
      setLoading(false);
      return;
    }
    const result = await response.json();
    return result;
  }

  // ===========================================دریافت نقش کاربر====================================================
  async function getUserRoles(serverUrl, token) {
    const response = await fetch(serverUrl + "api/Accountapi/GetUserRoleList", {
      method: 'GET',
      cache: 'no-cache',
      headers: {
        "Token": token,
        "Content-Type": "application/json",
        "Data-Type": "JSON"
      }
    });
    return await response.json();
  }

  // =============================================== دریافت اطلاعات شرکت ===============================================
  async function getCompanyInfo(compUrl, companyCode) {
    const response = await fetch(`${compUrl}CompanyAPI/GetCompany?RegisterCode=${companyCode}`, {
      method: "GET",
      cache: "no-cache"
    });
    return await response.json();
  }


  async function getResult(url, data) {
    try {
      const config = await loadConfig(data.CompanyCode);
      if (!config) {
        return;
      }
      const serverUrl = config.SERVER_URL;

      const loginResult = await login(serverUrl, url);

      if (!loginResult) return;

      if (!loginResult.status && loginResult.Message === "Error") {
        throw new Error("ConnectionError");
      }

      if (loginResult.status === 404) {
        throw new Error("NotFound");
      }

      if (loginResult.Message) {
        throw new Error(loginResult.Message);
      }

      localStorage.setItem("token", loginResult);

      const roles = await getUserRoles(serverUrl, loginResult);
      if (!roles.Message) {
        localStorage.setItem("RoleList", JSON.stringify(roles.RoleList));
        localStorage.setItem("UserInfo", JSON.stringify(roles.UserInfo));
      }

      if (data.CompanyCode && data.CompanyCode !== "") {
        try {
          const companyData = await getCompanyInfo(config.COMP_URL, data.CompanyCode);
          localStorage.setItem("Company", JSON.stringify(companyData));
          props.setUser(loginResult);
        } catch (companyErr) {
          console.error("[GetCompany]", companyErr);
          props.setUser(loginResult);
          setErrorDialog("خطا در دریافت اطلاعات شرکت", "ورود به سیستم");
        }
      } else {
        props.setUser(loginResult);
      }

      setLoading(false);
    } catch (err) {
      console.error("Login Error:", err);
      setLoading(false);
      setErrorDialog(err.message || "خطای نامشخص", "ورود به سیستم");
    }
  }



  function onSubmit(data) {

    const userUrl = url.replace('{username}', data.UserName).replace('{password}', data.Password);
    setLoading(true);
    getResult(userUrl, { username: data.UserName, Password: data.Password, CompanyCode: data.CompanyCode });

  }
  const { register, handleSubmit, errors } = useForm();
  return (
    <Fragment>
      <div className='logingPageLogoContainer'>
        <img src={company?.CompanyLogo} className='loginPageLogo' />
      </div>
      <div className="container justify-content-center d-flex loginContainer">
        {isLoading && <Loader type="BallTriangle" color="#bb1370" height={100} width={100} />}
        {!isLoading &&
          <Card className="flex-grow-1" style={{ margin: "auto", padding: 0 }}>
            <Card.Header className="headerStyle loginHeader">
              <h4 style={{ display: "inline-block" }}><FontAwesomeIcon icon={faDoorOpen} /> ورود به سامانه </h4>
            </Card.Header>
            <Card.Body className="bodyStyle  d-flex">
              <div style={{ flexGrow: 2 }} className='loginInfo'>
                <div className='loginTitle'>
                  <span></span>
                </div>
                <form onSubmit={handleSubmit(onSubmit)}>
                  {!company &&
                    <div className="form-group">
                      <div>
                        <label className='form-control' style={{ width: "50px", display: "inline-block", padding: "2.7px", textAlign: "center", borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }}>
                          <ShieldLock size={29} />
                        </label>
                        <Form.Control name="CompanyCode" placeholder='کد اکتیو' ref={register({ required: true })} style={{ display: "inline-block", width: "calc(100% - 50px)", borderTopRightRadius: 0, borderBottomRightRadius: 0 }} />
                      </div>
                      {errors.UserName && <small className="errors"> کد اکتیو اجباری است </small>}
                    </div>
                  }
                  <div className="form-group">
                    <div>
                      <label className='form-control' style={{ width: "50px", display: "inline-block", padding: "2.7px", textAlign: "center", borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }}>
                        <Person size={29} />
                      </label>
                      <Form.Control name="UserName" placeholder='نام کاربری' ref={register({ required: true })} style={{ display: "inline-block", width: "calc(100% - 50px)", borderTopRightRadius: 0, borderBottomRightRadius: 0 }} />
                    </div>
                    {errors.UserName && <small className="errors"> نام کاربری اجباری است </small>}
                  </div>
                  <br />
                  <div className="form-group mt-0">
                    <div>
                      <label className='form-control' style={{ width: "50px", display: "inline-block", textAlign: "center", padding: "2.7px", borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }}>
                        <Key size={29} />
                      </label>
                      <Form.Control name="Password" placeholder='رمز عبور' type="password" ref={register({ required: true })} style={{ display: "inline-block", width: "calc(100% - 50px)", borderTopRightRadius: 0, borderBottomRightRadius: 0 }} />
                    </div>
                    {errors.Password && <small className="errors"> رمز عبور را وارد کنید</small>}
                  </div>
                  <br />
                  <Button type="submit" className="w-100">ورود به سیستم</Button>
                </form>
              </div>
              {!isMobile &&
                <Col md={9} className='loginImageContainer'>
                  <img src={process.env.PUBLIC_URL + "/images/LoginImage.png"} className='loginImage' />
                </Col>
              }
            </Card.Body>
          </Card>
        }
      </div >
    </Fragment >)
}

export default Login;